import type { FolderDto } from "../../services/ApiService";
import FolderId from "../../state/FolderId";
import { fromLegacyPlatformIcon } from "../iconUtil";
import { toForm } from "./form";
import type { Folder } from "../../types/Folder";

export const toFolder = (dto: FolderDto): Folder => ({
  id: FolderId.from(dto.id),
  forms: dto.forms.map((formDto) => toForm(formDto, undefined)),
  status: dto.status,
  meta: {
    name: dto.meta.name,
    description: dto.meta.description,
    icon: fromLegacyPlatformIcon(dto.meta.icon, "folder"),
  },
});
